<div class="header">
  <div class="header-container">
    <h1 class="header-title-shopper">Merchant FAQ’s</h1>
    <br />
    <br />
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4><i class="fas fa-xs fa-info-circle"></i> 1. How does it work?</h4>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <p>
            ZeroPay offers your customers an alternative way to pay where they
            can shop now and pay later in 3 x, Zero fee, Zero interest payments.
            You arrange delivery of the goods straight away and we take care of
            the rest. <br />

            We pay you upfront and collect directly from the customer – this
            will increase your cash flow and also allows you to focus on
            delivery the goods while we focus on the rest. <br />

            There are no upfront or monthly fees, we only charge you on a
            transaction basis. The fee will be agreed to in the Merchant
            Agreement and depends on a few variables: your average basket size,
            transaction volume estimates and what e-commerce platform your store
            is hosted. <br />

            If you have further questions, please contact us! <br />
            If you are ready to join us as a partner, signup by following this<a
              mat-button-wrapper
              [routerLink]="['/merchant/signup']"
              class="a-link"
              target="_blank"
            >
              link.</a
            >
          </p>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4>
            <i class="fas fa-xs fa-info-circle"></i> 2. How do I become a
            Merchant?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            To signup, please complete the online signup form here
            <a
              class="a-link"
              mat-button-wrapper
              [routerLink]="['/merchant/signup']"
              >sign up.</a
            >
            <br />

            For any assistance, please email us at
            <a
              mat-button-wrapper
              class="a-link"
              href="mailto:partners@zeropay.co.za"
              >partners@zeropay.co.za</a
            >
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4>
            <i class="fas fa-xs fa-info-circle"></i>3. Can I accept ZeroPay as a
            payment option in-store and online?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>Yes our solution caters for online and in-store payments.</p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4>
            <i class="fas fa-xs fa-info-circle"></i>4. What integration is
            required?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We have plugins available for Woocommerce, Shopify and Magento (1
            and 2). These plugins enable a smooth customer experience and are
            readily available when you’re signed up! <br />
            <br />
            We also have an instalment calculator that you will be able to use
            to make it easy for your customers to know how much they are going
            to pay. <br />
            <br />
            If you don't have access to developer resources or need any
            additional assistance with the integration, our team is happy to
            assist!<br />
            <br />
            No integration is required for in-store use of our payment portal.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4>
            <i class="fas fa-xs fa-info-circle"></i> 5. When do I receive
            payment?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We make payments every Friday! If a transaction comes through before
            Wednesday, you will receive payment that same Friday, otherwise just
            the following Friday.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4>
            <i class="fas fa-xs fa-info-circle"></i>
            6. What happens if the shopper doesn’t pay their instalments?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We take care of this! We take all the risk and make sure that your
            mind is set at ease with the upfront payments (less our fee).
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4>
            <i class="fas fa-xs fa-info-circle"></i>7. Is there a contract term?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            There is no contract term - we want to work with you to grow your
            business and be a value-add to you and your customers. If ZeroPay
            does not work for you, all you have to do it turn the offering off.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h4>
            <i class="fas fa-xs fa-info-circle"></i> 8. Is there a minimum and
            maximum amount a shopper can apply for?
          </h4>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            There is no minimum or maximum amount. As long as the customer is
            able to make the immediate payment.
          </p>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="content">
      <br />
      <br />
      <br />
      <mat-divider></mat-divider>
      <br />
      <br />
      <br />
      <h1 class="header-title-shopper">
        Didn’t find the answer you were looking for?
      </h1>
      <br />
      <button mat-stroked-button (click)="showContact()" class="btn-action">
        CONTACT US
      </button>
    </div>
  </div>
</div>
